module.exports = __webpack_public_path__ + "static/media/fly0168.d403a0fe.webp";